import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col-span-10 w-full mt-x4 grid gap-x6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 order-last" }
const _hoisted_2 = { class: "w-2/5 block mx-auto" }
const _hoisted_3 = { class: "text-14 mt-x1" }
const _hoisted_4 = { class: "flex flex-nowrap justify-between mt-5" }

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { ModuleSofaProductItem } from '@/b2c/shared/api/server-apis';
import BasketLineItemImage from '@/b2c/basket/ui/line-items/parts/BasketLineItemImage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemModuleList',
  props: {
    modules: null
  },
  setup(__props: any) {



const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modules, (module) => {
      return (_openBlock(), _createElementBlock("div", {
        key: module.sku,
        class: _normalizeClass({'opacity-50': module.isDiscontinued})
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BasketLineItemImage, {
            sku: module.sku,
            alt: module.name,
            version: module.imageVersion
          }, null, 8, ["sku", "alt", "version"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString(module.name), 1),
          _createElementVNode("dl", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("dt", null, _toDisplayString(_unref(labels).lineItemSofaModuleQuantity), 1),
              _createVNode(_Transition, {
                name: "o-anim-fade-300",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("dd", {
                    key: module.quantity
                  }, _toDisplayString(module.quantity), 1))
                ]),
                _: 2
              }, 1024)
            ])
          ])
        ])
      ], 2))
    }), 128))
  ]))
}
}

})